import React from "react";

const Marketing = () => {
  const points1 = [
    <li>
      Identifiers: name, date of birth, address, telephone number(s), email
      address.
    </li>,
    <li>
      Protected Health Information (PHI): medical history, diagnoses,
      prescription details, refill history, laboratory data, and pharmacy
      information.
    </li>,
    <li>
      Sensitive information that may reveal mental-health conditions,
      substance-use disorder, HIV or other communicable diseases, genetic data,
      or developmental disabilities.
    </li>,
  ];
  const points2 = [
    <li>
      Send me marketing or promotional communications—such as
      prescription-pricing offers, coupons, refill reminders, and information
      about pharmaceutical, medical, or laboratory services—via the contact
      details in my UTIRX.com profile; and
    </li>,
    <li>
      Allow UTIRX.com or its Affiliates to receive direct or indirect
      compensation for such marketing activities.
    </li>,
  ];
  const points3 = [
    <li>
      Voluntary & No Conditions of Care. Refusal to sign will not affect your
      treatment, payment, enrollment, or eligibility for benefits.
    </li>,
    <li>
      Revocation. You may revoke this Authorization at any time by emailing
      Onlineutimeds@gmail.com or writing to the Privacy Officer listed below.
    </li>,
    <li>
      Revocation will not affect any use or disclosure already made in reliance
      on this Authorization.
    </li>,
    <li>
      Potential for Re-disclosure. Information disclosed to Affiliates under
      this Authorization may be re-disclosed and may no longer be protected
      under HIPAA. However, Affiliates are contractually required to safeguard
      your PHI.
    </li>,
    <li>
      HIPAA Privacy Rights. You retain all rights described in our Notice of
      Privacy Practices (NPP), including the rights to access, amend, restrict,
      or receive an accounting of disclosures of your PHI, request confidential
      communications, and file a privacy complaint.
    </li>,
  ];
  return (
    <div className="content-container">
      <h2>
        Authorization for Use & Disclosure of Information (Marketing Purposes)
        for UTIRX.com
      </h2>
      <p>
        <b>1. Information to Be Used and Disclosed</b>
      </p>
      <p>
        I authorize health-care providers contracted with UTIRX.com, LLC
        ("UTIRX.com"), and their independent medical groups and pharmacies
        (collectively, the "Providers") to use and disclose to UTIRX.com and its
        affiliated entities (collectively, “Affiliates”) the following
        information that I supply or that is collected during my care:
      </p>
      <ul>
        {points1.map((i) => {
          return i;
        })}
      </ul>
      <p>
        <b>2. Purpose of the Authorization</b>
      </p>
      <p>The PHI listed above may be used or disclosed solely to:</p>
      <ul>
        {points2.map((i) => {
          return i;
        })}
      </ul>
      <p>
        <b>3. Your Rights Concerning This Authorization</b>
      </p>
      <ul>
        {points3.map((i) => {
          return i;
        })}
      </ul>
      <p>
        <b>4. Our Legal Duties</b>
      </p>
      <p>
        UTIRX.com is a HIPAA-covered entity and is required by law to maintain
        the privacy and security of your PHI. We will use or disclose your PHI
        for marketing only as permitted by HIPAA and this Authorization, or as
        otherwise required by law. We will provide you with written notice of
        any breach of your unsecured PHI as defined by HIPAA.
      </p>
      <p>
        <b>5. Privacy Official & Contact Information</b>
      </p>
      <p>
        If you have questions about this Authorization or our privacy practices,
        or wish to exercise your HIPAA rights, contact:
      </p>
      <p>Privacy Officer: Dr. Arash Rafiei</p>
      <p>UTIRX.com, LLC</p>
      <p>Email: Onlineutimeds@gmail.com</p>
      <p>
        <b>Expiration</b>
      </p>
      <p>
        This Authorization remains in effect until the earliest of:
        <li>The date you revoke it in writing</li>
      </p>
      <p>
        You acknowledge that you have read and understand this Authorization and
        voluntarily grant UTIRX.com and its Affiliates permission to use and
        disclose your information as described above.
      </p>
    </div>
  );
};

export default Marketing;
